var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.625C5.72789 0.625 0.625 5.72789 0.625 12C0.625 18.2721 5.72789 23.375 12 23.375C18.2721 23.375 23.375 18.2721 23.375 12C23.375 5.72789 18.2721 0.625 12 0.625ZM17.9199 8.18773L10.5699 16.9377C10.4893 17.0338 10.389 17.1113 10.2758 17.1652C10.1625 17.2191 10.039 17.248 9.91367 17.25H9.89891C9.77626 17.25 9.655 17.2241 9.54298 17.1742C9.43096 17.1243 9.33069 17.0513 9.24867 16.9602L6.09867 13.4602C6.01867 13.3753 5.95644 13.2753 5.91564 13.1661C5.87483 13.0568 5.85628 12.9405 5.86106 12.824C5.86584 12.7075 5.89387 12.5931 5.94349 12.4876C5.99311 12.3821 6.06332 12.2875 6.15001 12.2095C6.23669 12.1315 6.33809 12.0716 6.44826 12.0333C6.55842 11.9951 6.67511 11.9792 6.79149 11.9867C6.90786 11.9942 7.02157 12.0249 7.12592 12.0769C7.23027 12.129 7.32317 12.2014 7.39914 12.2898L9.87594 15.0417L16.5801 7.06227C16.7305 6.8884 16.9432 6.7807 17.1724 6.76244C17.4015 6.74418 17.6286 6.81683 17.8047 6.96468C17.9807 7.11254 18.0914 7.32372 18.113 7.55258C18.1346 7.78144 18.0652 8.0096 17.9199 8.18773Z",
    fill: "#3DA06B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toastSuccess.2a6b846da490b9f53273227582768ed8.svg";
export { ForwardRef as ReactComponent };